import styled from "styled-components";
import { theme } from "../../styles/theme";

export const UserCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  width: 100%;
  height: 60px;
  background: ${theme.colors.light} 0% 0% no-repeat padding-box;
  border-radius: 12px;
  opacity: 1;
`;
